import ApplicationController from "../application_controller";
import * as tableModule from '../../packs/tabulator/tabulator';
import { TabulatorFull as Tabulator } from 'tabulator-tables';

export default class extends ApplicationController {
  static targets = ["tableWrapper", "table", "tableBar", "colToFilter"];
  static values = ["resizeObserver"];
  connect() {
    super.connect();
    
    // Check if this is a tabulator table
    if (this.element.classList.contains('table-section') && this.element.classList.contains('table-wrapper')) {
      this.initializeTabulator();
      return;
    }
    
    // Handle no-items rows visibility
    this.handleNoItemsRows();
    
    this.resizeObserverValue = new ResizeObserver((entries) => {
      for (const entry of entries) {
        if (entry.contentRect) {
          this.showAllCols();
          this.setColsVisibility(entry.contentRect.width);
          this.toggleBarBtn();
        }
      }
    });
    this.resizeObserverValue.observe(this.tableTarget.parentElement);
    const trs = this.tableTarget.querySelectorAll("tr");
    const cols = trs[0].querySelectorAll("th");
    this.colToFilterTarget.innerHTML = "";
    const opt = document.createElement("option");
    opt.value = -1;
    opt.innerHTML = "הכל";
    opt.selected = true;
    this.colToFilterTarget.appendChild(opt);

    cols.forEach((col, i) => {
      const opt = document.createElement("option");
      opt.value = i;
      opt.innerHTML = col.textContent;
      this.colToFilterTarget.appendChild(opt);
      col.addEventListener("click", (e) => {
        if (e.target.tagName == "TH") this.onColumnHeaderClicked(e);
      });
    });
    
    // Set up mutation observer to watch for dynamic content changes
    this.setupContentObserver();
  }

  handleNoItemsRows() {
    if (!this.tableTarget) return;
    
    const tbody = this.tableTarget.querySelector('tbody');
    if (!tbody) return;
    
    const noItemsRows = tbody.querySelectorAll('.table__row-noItems');
    const dataRows = tbody.querySelectorAll('tr:not(.table__row-noItems)');
    
    // Show no-items row only if there are no data rows
    const hasDataRows = dataRows.length > 0;
    
    noItemsRows.forEach(row => {
      row.style.display = hasDataRows ? 'none' : '';
    });
  }

  setupContentObserver() {
    if (!this.tableTarget) return;
    
    const tbody = this.tableTarget.querySelector('tbody');
    if (!tbody) return;
    
    // Create a mutation observer to watch for changes in table content
    this.contentObserver = new MutationObserver(() => {
      this.handleNoItemsRows();
    });
    
    // Start observing
    this.contentObserver.observe(tbody, {
      childList: true,
      subtree: true
    });
  }

  disconnect() {
    if (this.resizeObserverValue) {
      this.resizeObserverValue.disconnect();
    }
    if (this.contentObserver) {
      this.contentObserver.disconnect();
    }
    super.disconnect();
  }

  initializeTabulator() {
    const tableWrapper = this.element;
    
    // Ensure the wrapper has an ID
    if (!tableWrapper.id) {
      tableWrapper.id = `table-${Math.random().toString(36).substr(2, 9)}`;
    }
    
    // Check if table is already initialized
    if (tableModule.getTable(tableWrapper)) {
      return;
    }
    
    // Get columns and config from hidden elements if they exist
    let columns = [];
    let config = {};
    
    const columnsElement = tableWrapper.querySelector('.js-col-list');
    if (columnsElement) {
      try {
        columns = JSON.parse(columnsElement.textContent.trim());
      } catch (e) {
        console.error("Error parsing columns:", e);
      }
    }
    
    const configElement = tableWrapper.querySelector('.js-config-table');
    if (configElement) {
      try {
        config = JSON.parse(configElement.textContent.trim());
      } catch (e) {
        console.error("Error parsing config:", e);
      }
    }
    
    // Use the existing creatTabolatorTable function
    const table = tableModule.creatTabolatorTable(tableWrapper, this, '', {}, {
      pagination: "local",
      paginationSize: 25,
      selectableRows: 1,
      columns: columns.length > 0 ? columns : 'remove',
      ...config
    });
    // Store table reference in a global object
    window.tabulatorTables = window.tabulatorTables || {};
    window.tabulatorTables[tableWrapper.id] = table;
  }

  addColToggleCheckbox() {
    const trs = this.tableTarget.querySelectorAll(
      "tr:not(.table__row-noItems)"
    );
    const cols = trs[0].querySelectorAll("th");
    console.log(cols);
    const div = this.tableWrapperTarget.querySelector(".js-colList");
    if (div) {
      div.innerHTML = "";
      cols.forEach((col, i) => {
        div.appendChild(
          this.createCheckbox(
            col.textContent,
            i,
            !col.classList.contains("hide")
          )
        );
      });
    }
  }

  createCheckbox(header, i, checked) {
    var wrapper = document.createElement("div");

    // creating checkbox element
    var checkbox = document.createElement("input");

    // Assigning the attributes
    // to created checkbox
    const id = Date.now() + "-id-" + i;
    checkbox.type = "checkbox";
    checkbox.name = header;
    checkbox.value = i;
    checkbox.id = id;
    checkbox.checked = checked;
    checkbox.addEventListener("change", () => this.toggleColNum(i));

    // creating label for checkbox
    var label = document.createElement("label");

    // assigning attributes for
    // the created label tag
    label.htmlFor = id;

    // appending the created text to
    // the created label tag
    label.appendChild(document.createTextNode(header));

    // appending the checkbox
    // and label to div
    wrapper.appendChild(checkbox);
    wrapper.appendChild(label);
    wrapper.style.display = "flex";
    return wrapper;
  }
  toggleFullscreen() {
    this.tableWrapperTarget.classList.toggle("modal-fullscreen");
  }

  toggleColNum = function (num) {
    const trs = this.tableTarget.querySelectorAll(
      "tr:not(.table__row-noItems)"
    );

    trs.forEach((tr) => {
      const tds = tr.querySelectorAll("td , th");
      tds[num].classList.toggle("hide");
    });
  };

  setColsVisibility(wrapperWidth) {
    if (this.isOverflown(this.tableTarget.parentElement)) {
      this.hideCol();
      this.setColsVisibility(wrapperWidth);
    }
    this.addColToggleCheckbox();
  }

  hideCol() {
    const trs = this.tableTarget.querySelectorAll(
      "tr:not(.table__row-noItems)"
    );
    const colNum = trs[0].querySelectorAll("th:not(.hide)").length;

    trs.forEach((tr) => {
      const tds = tr.querySelectorAll("td , th");
      tds[colNum - 1].classList.add("hide");
    });
  }
  showAllCols() {
    const tds = this.tableTarget.querySelectorAll("td , th");
    tds.forEach((td) => {
      td.classList.remove("hide");
    });
  }

  toggleBarBtn() {
    if (this.tableBarTarget.clientWidth < 300)
      this.tableBarTarget.classList.add("small");
    else this.tableBarTarget.classList.remove("small");
  }

  isOverflown(element) {
    return element.scrollWidth > element.clientWidth;
  }

  tableToCSV(e) {
    e.preventDefault();
    // Variable to store the final csv data
    var csv_data = [];

    // Get each row data
    var rows = this.tableTarget.querySelectorAll("tr");
    for (var i = 0; i < rows.length; i++) {
      // Get each column data
      var cols = rows[i].querySelectorAll("td,th");

      // Stores each csv row data
      var csvrow = [];
      for (var j = 0; j < cols.length; j++) {
        // Get the text data of each cell
        // of a row and push it to csvrow
        csvrow.push(this.checkForText(cols[j]));
      }

      // Combine each column value with comma
      csv_data.push(csvrow.join(","));
    }

    // Combine each row data with new line character
    csv_data = csv_data.join("\n");

    // add UTF-8 BOM to beginning so excel doesn't get confused.
    const BOM = String.fromCharCode(0xfeff);
    csv_data = BOM + csv_data;
    // Call this function to download csv file
    this.downloadCSVFile(csv_data);
  }

  downloadCSVFile(csv_data) {
    // Create CSV file object and feed
    // our csv_data into it
    const CSVFile = new Blob([csv_data], {
      type: "text/csv;charset=UTF-8",
    });

    // Create to temporary link to initiate
    // download process
    var temp_link = document.createElement("a");

    // Download csv file
    temp_link.download = "GfG.csv";
    var url = window.URL.createObjectURL(CSVFile);
    temp_link.href = url;

    // This link should not be displayed
    temp_link.style.display = "none";
    document.body.appendChild(temp_link);

    // Automatically click the link to
    // trigger download
    temp_link.click();
    document.body.removeChild(temp_link);
  }

  search(e) {
    // Declare variables
    var input, filter, table, tr, td, i, n, txtValue, col;
    input = e.target;
    filter = input.value.toUpperCase();
    table = this.tableTarget;
    const rows = Array.from(
      table.querySelectorAll(":scope > tbody > tr:not(.table__row-noItems)")
    );
    tr = table.getElementsByTagName("tr");
    col = this.colToFilterTarget.value;
    rows.forEach((row) => {
      row.style.display = "none";
    });

    const filteredRows = rows.filter((row) => {
      txtValue = "";
      const cellsTextArr = Array.from(row.cells).map((cell) =>
        this.checkForText(cell)
      );
      console.log(cellsTextArr);

      if (col == -1) {
        txtValue = cellsTextArr.join(" ");
        console.log(txtValue);
      } else {
        txtValue = cellsTextArr[col];
      }
      return txtValue == "" || txtValue.toUpperCase().indexOf(filter) > -1;
    });
    filteredRows.forEach((row) => {
      row.style.display = "";
    });

    for (let row of rows) {
      table.tBodies[0].appendChild(row);
    }
  }

  checkForText(td) {
    if (!td || td.className == "td-actions") return "";
    console.log(td.dataset);

    if (td.dataset && td.dataset.text) return td.dataset.text;
    if (td.querySelector("input[type=checkbox]"))
      return td.querySelector("input[type=checkbox]").checked ? "1" : "0";
    if (td.querySelector("input")) return td.querySelector("input").value;
    if (td.querySelector("textarea")) return td.querySelector("textarea").value;
    if (td.querySelector("select"))
      return td.querySelector("select").options[
        td.querySelector("select").selectedIndex
      ].text;
    return td.innerText;
  }

  // This code has TypeScript type annotations, but can be used directly as pure JavaScript by just removing the type annotations first.

  sortTableRowsByColumn(table, columnIndex, ascending) {
    const rows = Array.from(
      table.querySelectorAll(":scope > tbody > tr:not(.table__row-noItems)")
    );

    try {
      rows.sort((x, y) => {
        const xValue = this.checkForText(x.cells[columnIndex]) || "";
        const yValue = this.checkForText(y.cells[columnIndex]) || "";
      
        // Natural sort for Hebrew strings with optional numbers
        const extract = (str) => {
          const match = str.match(/^(.*?)(\d+)?\s*$/);
          return [match?.[1]?.trim() || "", parseInt(match?.[2] || "0", 10)];
        };
      
        const [xText, xNum] = extract(xValue);
        const [yText, yNum] = extract(yValue);
      
        const textCompare = xText.localeCompare(yText, "he");
      
        if (textCompare === 0) {
          return ascending ? xNum - yNum : yNum - xNum;
        }
      
        return ascending ? textCompare : -textCompare;
      });
    } catch (error) {
      console.error("Error sorting table rows by column:", error);
      rows.sort((x, y) => {
        const xValue = this.checkForText(x.cells[columnIndex]);
        const yValue = this.checkForText(y.cells[columnIndex]);
  
        const xNum = parseFloat(xValue);
        const yNum = parseFloat(yValue);
  
        if (isNaN(xNum) || isNaN(yNum)) {
          return ascending
            ? xValue.localeCompare(yValue)
            : yValue.localeCompare(xValue);
          // <-- Neat comparison trick.
        }
        return ascending ? yNum - xNum : xNum - yNum; // <-- Neat comparison trick.
      });
    }

    // There is no need to remove the rows prior to adding them in-order because `.appendChild` will relocate existing nodes.
    for (let row of rows) {
      table.tBodies[0].appendChild(row);
    }
  }

  onColumnHeaderClicked(ev) {
    const th = ev.currentTarget;
    const table = th.closest("table");
    const thIndex = Array.from(th.parentElement.children).indexOf(th);

    const ascending = th.dataset.sort != "asc";

    this.sortTableRowsByColumn(table, thIndex, ascending);
    const allTh = table.querySelectorAll(":scope > thead > tr > th");
    for (let th2 of allTh) {
      delete th2.dataset["sort"];
      th2.classList.remove("asc");
      th2.classList.remove("desc");
    }
    th.dataset.sort = ascending ? "asc" : "desc";
    th.classList.toggle("asc", ascending);
    th.classList.toggle("desc", !ascending);
  }

  exportToXlsx(e) {
    try {
      const wrapper = this.element;
      const table = tableModule.getTable(wrapper);
      
      if (!table) {
        throw new Error("Table instance not found");
      }
      
      const fileName = `${e.target.dataset.filename || 'table_export'}_${new Date().toISOString().slice(0, 10)}.xlsx`;
      tableModule.exportAsXlsx(table, fileName);
    } catch (error) {
      console.error("Error exporting to Excel:", error);
      alert("שגיאה בייצוא לאקסל. נסה שוב מאוחר יותר.");
    }
  }

  export_to_pdf(e) {
    try {
      const wrapper = this.element;
      const table = tableModule.getTable(wrapper);
      
      if (!table) {
        throw new Error("Table instance not found");
      }
      
      const fileName = `${e.target.dataset.filename || 'table_export'}_${new Date().toISOString().slice(0, 10)}.pdf`;
      tableModule.exportAsPdf(table, fileName);
    } catch (error) {
      console.error("Error exporting to PDF:", error);
      alert("שגיאה בייצוא ל-PDF. נסה שוב מאוחר יותר.");
    }
  }
}